export const UPLOAD_DELAY_MS = 1000;
export const DEFAULT_SERVICE_NAME = "document-ai";
export const MERGED_FILES_NAME = "merged_files";
